<template>
  <div class="returnRefundPolicy">
    <section class="main_section">
      <div class="page-contentbox">
        <a @click="goBack" class="back-link">
          <i class="material-icons">arrow_back_ios</i> Back
        </a>

        <h2>Return & Refund Policy</h2>

        <p>You have the right to cancel your order within 7 working days from delivery. You must notify us by email of your intention to cancel within 7 working days from delivery.</p>

        <p>Goods must be returned 'AS SOLD' in the original condition.</p>

        <p>Goods must be complete, unused, and in 'AS NEW' condition (eg if you have opened the box to examine the product it must have been done so without damaging the box and packaging or damaging the product in any way) and must be re-packaged as received.</p>

        <p>Goods must be returned to our Returns Department within 7 days from authorisation. We are unable to accept returns of un-wanted and non-faulty items after the 7 days.</p>

        <p>Any 'FREE GIFTS' with the products must also be returned.</p>
        <p>
          311, Mamram East Plaza,
          <br />Plot No 192, Sector G,
          <br />Mayur Vihar, Phase 3,
          <br />Delhi - 110096
        </p>
        <h4>Please note :</h4>

        <p>You must organise the return of the unwanted items at your expense and risk. The returns authorisation is valid for up to 7 days only. Goods sent back without prior returns authorisation will be returned back to you and the cost of delivery charged to your account.</p>

        <h4>Refunds :</h4>

        <p>Full refund of the cost of the goods is wholly conditional upon the above conditions being met and the refund authorised only after a full inspection of the goods by our Returns department to check for completeness and correct product return.</p>

        <p>Goods received back complete as NEW and unused and in a re-sellable condition: You will be refunded the full invoice amount.</p>

        <p>Goods received back not in a resalable condition: We are unable to accept these back under the above terms and the goods will be returned back to you and the cost of delivery charged to your account.</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ReturnRefundPolicy",
  data() {
    return {
      msg: "Welcome to Your Vue.js PWA"
    };
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
